<template>
  <div>
    <div
      class="side-overlay"
      :class="{ open: visible }"
      @click="$emit('close')"
    ></div>

    <aside class="side-menu" :class="{ open: visible }">
      <div class="side-header">
        <img src="/logo.png" alt="" @click="go('/home')" />
        <button type="button" class="close-btn" @click="$emit('close')">
          ×
        </button>
      </div>

      <div v-if="panel === 'menu'" class="menu-grid">
        <button
          v-for="item in menuItems"
          :key="item.key"
          type="button"
          class="menu-item"
          :disabled="item.action === 'logout' && isLoggingOut"
          @click="onItemClick(item)"
        >
          <img class="icon-img" :src="item.icon" alt="" />
          <span class="label">
            <Loading
              v-if="item.action === 'logout' && isLoggingOut"
              size="16"
              color="#f7d56a"
            />
            <template v-else>{{ itemLabel(item) }}</template>
          </span>
        </button>
      </div>

      <div v-else-if="panel === 'language'" class="lang-panel">
        <button type="button" class="back-lang" @click="panel = 'menu'">
          ← {{ $t("setting.update_language") }}
        </button>
        <button
          type="button"
          class="lang-item"
          v-for="lang in languages"
          :key="lang.code"
          @click="setLanguage(lang.code)"
        >
          <img :src="lang.flag" alt="" />
          <span>{{ $t(lang.code) }}</span>
        </button>
      </div>

      <div v-else class="password-panel">
        <button type="button" class="back-lang" @click="panel = 'menu'">
          ← {{ $t("setting.update_password") }}
        </button>
        <label>{{ $t("setting.old_password") }}</label>
        <input v-model="password.old" type="password" />
        <span class="error">{{ errors.old }}</span>
        <label>{{ $t("setting.new_password") }}</label>
        <input v-model="password.new" type="password" />
        <span class="error">{{ errors.new }}</span>
        <label>{{ $t("setting.confirm_password") }}</label>
        <input v-model="password.confirm" type="password" />
        <span class="error">{{ errors.confirm || errors.confirmPassword }}</span>
        <button type="button" class="update-btn" @click="changeNewPassword">
          {{ $t("setting.update") }}
        </button>
      </div>
    </aside>
  </div>
</template>

<script>
import { Toast, Dialog, Loading } from "vant";
import { mapActions, mapState } from "vuex";

export default {
  components: { Loading },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      panel: "menu",
      isLoggingOut: false,
      password: {
        user_id: null,
        old: "",
        new: "",
        confirm: "",
      },
      errors: {},
      languages: [
        {
          code: "en",
          flag: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/united-kingdom.png",
        },
        {
          code: "mm",
          flag: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/myanmar.png",
        },
        {
          code: "cn",
          flag: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/china.png",
        },
        {
          code: "th",
          flag: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/thailand.png",
        },
      ],
      menuItems: [
        {
          key: "name",
          label: "setting.name",
          action: "none",
          icon: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Name%20(1).png",
        },
        {
          key: "deposit",
          label: "setting.deposit",
          path: "/deposit",
          icon: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Deposit%20(4).png",
        },
        {
          key: "withdraw",
          label: "setting.withdraw",
          path: "/withdraw",
          icon: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Withdraw%20(2).png",
        },
        {
          key: "transaction",
          label: "setting.transaction",
          path: "/history",
          icon: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Money%20List.png",
        },
        {
          key: "voucher",
          label: "setting.voucher",
          path: "/betslip-history",
          icon: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Voucher%20(2).png",
        },
        {
          key: "password",
          label: "setting.update_password",
          action: "password",
          icon: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Password.png",
        },
        {
          key: "rule",
          label: "setting.rule",
          path: "/rule",
          icon: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Rules.png",
        },
        {
          key: "sound",
          label: "setting.sound",
          action: "sound",
          icon: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Sound.png",
        },
        {
          key: "language",
          label: "setting.update_language",
          action: "language",
          icon: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Language.png",
        },
        {
          key: "logout",
          label: "setting.logout",
          action: "logout",
          icon: "https://yy24gld.sgp1.cdn.digitaloceanspaces.com/general/Exit.png",
        },
      ],
    };
  },
  computed: {
    ...mapState(["authUser"]),
  },
  watch: {
    visible(val) {
      if (!val) {
        this.panel = "menu";
        this.errors = {};
      } else {
        this.password.user_id = this.authUser && this.authUser.id;
      }
    },
  },
  methods: {
    ...mapActions(["logoutUser"]),
    itemLabel(item) {
      if (item.key === "name") {
        return `${this.$t("setting.name")} - ${
          (this.authUser && (this.authUser.user_name || this.authUser.name)) ||
          ""
        }`;
      }
      if (item.key === "sound") {
        const on =
          this.$store.state.language === "en"
            ? this.$store.state.music
              ? "On"
              : "Off"
            : this.$store.state.music
            ? "ဖွင့်"
            : "ပိတ်";
        return `${this.$t(item.label)} (${on})`;
      }
      return this.$t(item.label);
    },
    go(path) {
      this.$playSound();
      this.$emit("close");
      this.$router.push(path).catch(() => {});
    },
    onItemClick(item) {
      if (item.action === "logout" && this.isLoggingOut) return;
      this.$playSound();
      if (item.action === "none") return;
      if (item.action === "language") {
        this.panel = "language";
        return;
      }
      if (item.action === "password") {
        this.panel = "password";
        return;
      }
      if (item.action === "sound") {
        this.$store.commit("setMusic", !this.$store.state.music);
        return;
      }
      if (item.action === "logout") {
        this.logout();
        return;
      }
      this.$emit("close");
      this.$router.push(item.path).catch(() => {});
    },
    setLanguage(language) {
      this.$playSound();
      localStorage.setItem("language", language);
      this.$store.commit("setLanguage", language);
      this.$i18n.locale = language;
      this.panel = "menu";
    },
    changeNewPassword() {
      this.errors = {};
      if (!this.password.old) {
        this.errors.old =
          this.$store.state.language === "en"
            ? "Old password required"
            : "လျို့ဝှက်နံပါတ်အဟောင်း ထည့်ပါ။";
        return;
      }
      if (!this.password.new) {
        this.errors.new =
          this.$store.state.language === "en"
            ? "New password required"
            : "လျို့ဝှက်နံပါတ်အသစ် ထည့်ပါ။";
        return;
      }
      if (!this.password.confirm) {
        this.errors.confirm =
          this.$store.state.language === "en"
            ? "Confirm password required"
            : "အတည်ပြုလျို့ဝှက်နံပါတ် ထည့်ပါ။";
        return;
      }
      if (this.password.new !== this.password.confirm) {
        this.errors.confirmPassword =
          this.$store.state.language === "en"
            ? "New passwords not match"
            : "လျှို့ဝှက်နံပါတ် မတူညီပါ။";
        return;
      }
      Dialog.confirm({
        title:
          this.$store.state.language === "en" ? "Are you sure?" : "သေချာပါသလား?",
        cancelButtonText:
          this.$store.state.language === "en" ? "Cancel" : "မလုပ်တော့ပါ။",
        confirmButtonText:
          this.$store.state.language === "en" ? "Sure" : "သေချာပြီ။",
      })
        .then(() => {
          this.updateUser();
        })
        .catch(() => {});
    },
    async updateUser() {
      try {
        await axios.post("/auth/userPasswordChange", this.password, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        Toast.success(
          this.$store.state.language === "en" ? "Success" : "အောင်မြင်သည်။"
        );
        this.password = {
          user_id: this.authUser && this.authUser.id,
          old: "",
          new: "",
          confirm: "",
        };
        this.errors = {};
        this.panel = "menu";
      } catch (error) {
        Toast.fail(this.$store.state.language === "en" ? "Fail" : "ကျရှုံးသည်။");
      }
    },
    async logout() {
      if (this.isLoggingOut) return;
      this.isLoggingOut = true;
      try {
        await this.logoutUser();
        this.$emit("close");
        Toast.success(
          this.$store.state.language === "en" ? "Logged out!" : "ထွက်ပြီးပြီ"
        );
        this.$router.push("/welcome");
      } catch (error) {
        this.isLoggingOut = false;
      }
    },
  },
};
</script>

<style scoped>
.side-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.62);
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.25s ease;
  z-index: 12000;
}

.side-overlay.open {
  opacity: 1;
  pointer-events: auto;
}

.side-menu {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  padding: 12px 12px 24px;
  color: #f5f5f5;
  background: #0c0c0c;
  transform: translateX(-105%);
  transition: transform 0.28s ease;
  z-index: 12001;
  overflow-y: auto;
}

.side-menu.open {
  transform: translateX(0);
}

.side-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  padding: 0 4px;
}

.side-header img {
  height: 36px;
}

.close-btn {
  width: 32px;
  height: 32px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  color: #f7d56a;
  font-size: 1.5rem;
  line-height: 1;
}

.menu-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

.menu-item {
  min-height: 92px;
  padding: 12px 8px 10px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  background: #1c1c1c;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.menu-item:active {
  background: #1a1a1a;
}

.menu-item:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.icon-img {
  width: 28px;
  height: 28px;
}

.label {
  margin-top: 8px;
  font-size: 0.82rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.25;
  color: #f0e6c8;
}

.lang-panel,
.password-panel {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.back-lang,
.lang-item,
.update-btn {
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  background: #1c1c1c;
  color: #f0e6c8;
  padding: 12px;
  text-align: left;
  font-weight: 600;
}

.lang-item {
  display: flex;
  align-items: center;
}

.lang-item img {
  width: 22px;
  height: 22px;
  margin-right: 10px;
  border-radius: 50%;
}

.password-panel label {
  color: #b8b3a8;
  font-size: 0.82rem;
  margin-top: 4px;
}

.password-panel input {
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  background: #171717;
  color: #fff;
  padding: 10px 12px;
}

.error {
  color: #ff7a59;
  font-size: 0.75rem;
  min-height: 1em;
}

.update-btn {
  text-align: center;
  background: linear-gradient(180deg, #f7d56a, #e7b534);
  color: #1a1408;
  border: 0;
  margin-top: 8px;
}
</style>
